import React from 'react'
import { resolveColorHex } from '../config/colorPalette'

const Color = ({ children , props, selected}) =>{
    const divStyle = {
        backgroundColor: resolveColorHex(children),
    }
    const handleClick = (e) => {
      e.stopPropagation();
      if (typeof props === 'function') props(children);
    };
  return (
    <div
      onClick={handleClick}
      style={divStyle}
      title={children}
      className={`rounded-circle color-circle-main${selected ? ' color-circle-selected' : ''}`}
    ></div>
  )
}
export default Color
